// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
export const isEnglishLang = (): boolean =>
  navigator.language.split('-')[0].toLocaleLowerCase() === 'en';

export const isIphone = () => navigator.platform === 'iPhone' && navigator.maxTouchPoints > 0;
